import { defineMessages } from 'react-intl';

import GroupButtonEdit from './GroupButtonEdit';
import GroupButtonView from './GroupButtonView';
import { GroupButtonSchema } from './schema';

import iconSVG from '../Button/icons/button.svg';

defineMessages({
  groupButton: { id: 'Group Button', defaultMessage: 'Group Button' },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.groupButtonBlock = {
    id: 'groupButtonBlock',
    title: 'Group Button',
    group: 'text',
    icon: iconSVG,
    view: GroupButtonView,
    edit: GroupButtonEdit,
    blockSchema: GroupButtonSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
